import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
import { SET_TOP_BAR_VISIBILITY, SET_BOTTOM_NAV_BAR_VISIBILITY } from "../store/action-types";
import { COMPONENT_VISIBILITY } from "../types";
import User from "../entities/User";

import SignInUpView from "../views/SignInSignUpView.vue";
import SignOutView from "../views/SignOutView.vue";
import DebugView from "../views/DebugView.vue";
import AdminView from "../views/AdminView.vue";
import LandingView from "../views/LandingView.vue";

Vue.use(Router);

const publicRoutes = ["sign-in", "sign-up", "sign-out", "home"];
const pagesToHideTopBar = ["sign-in", "sign-up", "sign-out", "home"];

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: LandingView,
    },
    {
      path: "/sign-in",
      name: "sign-in",
      component: SignInUpView,
    },
    {
      path: "/sign-up",
      name: "sign-up",
      component: SignInUpView,
    },
    {
      path: "/sign-out",
      name: "sign-out",
      component: SignOutView,
    },
    {
      path: "/projects",
      name: "projects",
      component: () => import("../views/ProjectsView.vue"),
    },
    {
      path: "/projects/:projectId",
      component: () => import("../views/ProjectDetailView.vue"),
      children: [
        {
          path: "",
          redirect: "languages",
        },
        {
          path: "languages",
          name: "project-languages",
          component: () => import("../views/project-detail/LanguagesTab.vue"),
        },
        {
          path: "languages/:code",
          name: "project-translations-by-language",
          component: () => import("../views/project-detail/TranslationsByLanguageView.vue"),
        },
        {
          path: "terms",
          name: "project-terms",
          component: () => import("../views/project-detail/TermsTab.vue"),
        },
        {
          path: "import",
          name: "project-import",
          component: () => import("../views/project-detail/ImportTab.vue"),
        },
        {
          path: "export",
          name: "project-export",
          component: () => import("../views/project-detail/ExportTab.vue"),
        },
      ],
    },
    {
      path: "/debug",
      name: "debug",
      component: DebugView,
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminView,
    },
    {
      path: "*",
      redirect: "/projects",
    },
  ],
});

router.beforeEach((to, _from, next) => {
  const authRequired = !publicRoutes.includes(to.name || "");
  const userIsAuthenticated = store.getters["auth/user"] instanceof User;
  const askForAuthentication = authRequired && !userIsAuthenticated;

  if (askForAuthentication || pagesToHideTopBar.includes(to.name || "")) {
    store.commit(`app/${SET_TOP_BAR_VISIBILITY}`, COMPONENT_VISIBILITY.hidden);
  } else {
    store.commit(`app/${SET_TOP_BAR_VISIBILITY}`, COMPONENT_VISIBILITY.visible);
  }

  store.commit(`app/${SET_BOTTOM_NAV_BAR_VISIBILITY}`, COMPONENT_VISIBILITY.hidden);

  if (askForAuthentication) {
    next("/sign-in");
  } else {
    next();
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    if (to) {
      const title = to.name || "ParlaEditor";
      document.title = title;
    }
  });
});

export default router;
